export const APP_ROUTES = {
  home: "/home",
  api: "/api-keys",
  models: "/models",
  studio: "/studio",
  integrations: "/guides",
  docs: "/docs/getting-started",
  referrals: "/referrals",
  support: "/support",
  functions: "/functions",
  billing: "/billing",
  profile: "/profile",
};

const PRIVATE_ROOTS = new Set([
  "home", "api-keys", "studio", "referrals", "support", "functions", "billing", "profile",
]);

export function isPrivatePath(pathname) {
  return PRIVATE_ROOTS.has(pathname.split("/")[1]);
}

export function legacyAppPath(pathname) {
  if (pathname === "/app") return APP_ROUTES.home;
  if (!pathname.startsWith("/app/")) return null;
  const [screen, ...segments] = pathname.slice(5).replace(/\/+$/, "").split("/");
  const base = screen === "statistics" ? APP_ROUTES.billing
    : Object.hasOwn(APP_ROUTES, screen) ? APP_ROUTES[screen] : null;
  if (!base) return APP_ROUTES.home;
  if (screen === "docs" && segments.some(Boolean)) return `/docs/${segments.join("/")}`;
  return `${base}${segments.length ? `/${segments.join("/")}` : ""}`;
}
